import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['filterButton', 'body', 'header'];

  toggle() {
    this.headerTarget.classList.toggle('is-open');

    if (this.headerTarget.classList.contains('is-open')) {
      this.bodyTarget.style.height = `${this.bodyTarget.scrollHeight}px`;

      if (this.hasFilterButtonTarget) {
        this.filterButtonTarget.style.display = 'none';
      }
    } else {
      this.bodyTarget.style.height = '0';

      if (this.hasFilterButtonTarget) {
        this.filterButtonTarget.style.display = 'block';
      }
    }
  }
}
